import React, { useEffect, useRef } from 'react';

const SupportSearchBar = ({ query, onQueryChange, suggestions = [], onSelectSuggestion, onSubmit }) => {
  const inputRef = useRef(null);
  const showSuggestions = query.trim().length > 0 && suggestions.length > 0;

  useEffect(() => {
    if (onSubmit && inputRef.current) {
      const handler = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          onSubmit();
        }
      };
      const node = inputRef.current;
      node.addEventListener('keydown', handler);
      return () => node.removeEventListener('keydown', handler);
    }
  }, [onSubmit]);

  return (
    <div style={{ position: 'relative' }}>
      <div className="support-search">
        <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" fill="none">
          <circle cx="11" cy="11" r="7" strokeWidth="1.5" />
          <path d="M20 20l-3.5-3.5" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <input
          ref={inputRef}
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search help articles"
        />
        <button type="button" className="support-btn" onClick={onSubmit}>Search</button>
      </div>
      {showSuggestions && (
        <div className="support-search-suggestions" role="listbox">
          {suggestions.map((item) => (
            <div
              key={item.id}
              role="option"
              tabIndex={0}
              className="support-search-suggestion"
              onClick={() => onSelectSuggestion(item)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') onSelectSuggestion(item);
              }}
            >
              {item.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SupportSearchBar;
